import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSelectInput} from "../abstract-select-input";
import {FUIEventsService} from "../../../../events/events.service";import {FUIOptionsService} from "../../../framework/options.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPillSelectInputComponent),
            multi: true
        }
    ],
    selector: "fui-pill-select-input",
    styleUrls: ["../select-input.scss"],
    templateUrl: "./pill-select-input.component.html",
    standalone: false
})
export class FUIPillSelectInputComponent extends FUIAbstractSelectInput {

    /**
     * Indicates if the pill can be removed
     */
    @Input() public removable: boolean;
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(elementRef, changeDetectorRef, eventsService, optionsService);
    }
}
